import { emailRequired, phoneNumberRequired, stringRequired } from '@nexans/react-form/zod'
import * as z from 'zod'

import { PublicDto } from '@/types'
import { Civility, CompanySize, Language } from '@/types/openapi-public'

export type RegistrationFormValues = PublicDto['RegisterUserCommand'] & {
  hasAcceptedTerms: boolean
}

/**
 * Register form validation schema
 */
export const RegisterUserSchema = z.object({
  companyName: stringRequired()
    .max(100, 'errors.auth.company_name_max_length')
    .regex(/^[\p{L}\p{N}][\p{L}\p{N} .,'&%()\-_/+@:]*$/u, 'errors.auth.company_name_pattern'),
  companySize: z.enum(CompanySize),
  companyAddress: stringRequired(),
  civility: z.enum(Civility),
  email: emailRequired(),
  firstName: stringRequired().max(50, 'errors.auth.first_name_max_length'),
  lastName: stringRequired().max(50, 'errors.auth.last_name_max_length'),
  phoneNumber: phoneNumberRequired(),
  preferredLanguage: z.enum(Language),
  hasConsentedMarketing: z.boolean(),
}) satisfies z.ZodType<PublicDto['RegisterUserCommand']>

export const RegistrationFormSchema = RegisterUserSchema.extend({
  hasAcceptedTerms: z.boolean().refine((value) => value, 'form.required'),
}) satisfies z.ZodType<RegistrationFormValues>

/**
 * OTP form validation schema
 */
export const VerifyUserSchema = z.object({
  sessionId: stringRequired(),
  code: stringRequired().length(6, 'errors.auth.otp_6_chars'),
}) satisfies z.ZodType<PublicDto['VerifyUserCommand']>

/**
 * Sign in form validation schema
 */
export const SigninUserSchema = z.object({
  email: emailRequired(),
}) satisfies z.ZodType<PublicDto['SigninUserCommand']>

/**
 * Resend activation mail
 */
export const ResendUserActivationSchema = z.object({
  sessionId: stringRequired(),
}) satisfies z.ZodType<PublicDto['ResendUserActivationCommand']>
